"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSvgIcon = void 0;
var react_1 = __importDefault(require("react"));
/* Helps ensure refs are passed as props to each component */
function buildSvgIcon(content, displayName, defaultSvgProps) {
    if (defaultSvgProps === void 0) { defaultSvgProps = {}; }
    var component = react_1.default.forwardRef(function (props, ref) {
        var rootProps = __assign(__assign(__assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: defaultSvgProps.viewBox || '0 0 24 24', ref: ref }, defaultSvgProps), props), { style: __assign(__assign({ fill: 'none' }, (defaultSvgProps.style || {})), (props.style || {})) });
        return (react_1.default.createElement("svg", __assign({}, rootProps), typeof content === 'function' ? content() : content));
    });
    component.displayName = displayName;
    return react_1.default.memo(component);
}
exports.buildSvgIcon = buildSvgIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGQtc3ZnLWljb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9kZXNpZ24tc3lzdGVtLWljb25zL2J1aWxkLXN2Zy1pY29uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGdEQUEwQjtBQVcxQiw2REFBNkQ7QUFDN0QsU0FBZ0IsWUFBWSxDQUMxQixPQUEwQyxFQUMxQyxXQUFtQixFQUNuQixlQUFtRDtJQUFuRCxnQ0FBQSxFQUFBLG9CQUFtRDtJQUVuRCxJQUFNLFNBQVMsR0FBRyxlQUFLLENBQUMsVUFBVSxDQUNoQyxVQUFDLEtBQXVCLEVBQUUsR0FBZ0M7UUFDeEQsSUFBTSxTQUFTLGdDQUNiLEtBQUssRUFBRSw0QkFBNEIsRUFDbkMsT0FBTyxFQUFFLGVBQWUsQ0FBQyxPQUFPLElBQUksV0FBVyxFQUMvQyxHQUFHLEtBQUEsSUFDQSxlQUFlLEdBQ2YsS0FBSyxLQUNSLEtBQUssc0JBQ0gsSUFBSSxFQUFFLE1BQU0sSUFDVCxDQUFDLGVBQWUsQ0FBQyxLQUFLLElBQUksRUFBRSxDQUFDLEdBQzdCLENBQUMsS0FBSyxDQUFDLEtBQUssSUFBSSxFQUFFLENBQUMsSUFFekIsQ0FBQztRQUNGLE9BQU8sQ0FDTCxrREFBUyxTQUFTLEdBQ2YsT0FBTyxPQUFPLEtBQUssVUFBVSxDQUFDLENBQUMsQ0FBQyxPQUFPLEVBQUUsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUNoRCxDQUNQLENBQUM7SUFDSixDQUFDLENBQ0YsQ0FBQztJQUVGLFNBQVMsQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDO0lBRXBDLE9BQU8sZUFBSyxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQztBQUMvQixDQUFDO0FBOUJELG9DQThCQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/design-system-icons/build-svg-icon.js
// module id = 22
// module chunks = 25